export default __webpack_public_path__ + "static/media/Hospitality.74d46440.jpg";